<template>
  <case :banner="Banner" :box1="box1" :box2="box2">
    <v-row>
      <v-col cols="12">
        <highlight-container even class="pa-0">
          <p class="text-body" v-html="intro" />
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container
          even
          class="pa-0"
          title="Resultados com o selo eureciclo"
        >
          <v-list dense>
            <v-list-item v-for="(result, i) in results" :key="i">
              <v-list-item-icon>
                <v-img
                  :src="require('@/assets/images/materialicons/check.svg')"
                />
              </v-list-item-icon>
              <v-list-item-content
                class="text-body"
                :style="{ color: color }"
                v-html="result"
              />
            </v-list-item>
          </v-list>
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container class="pa-0" even title="O desafio da marca">
          <div class="text-body">
            <p>
              A Vida Veg se posiciona como uma marca saudável, consciente e
              inteligente e acredita que a alimentação une as pessoas. Através
              da união entre a tecnologia e a natureza, a empresa prova como é
              possível e necessária a inovação com responsabilidade
              socioambiental, de forma a caminharmos rumo a um futuro melhor.
            </p>
            <p>
              Por comercializar alimentos de base 100% vegetal, a marca
              contribui indiretamente para a redução do desmatamento, a
              diminuição das emissões de gases estufa e do consumo de água, além
              de valorizar e preservar a vida animal. Em 5 anos de empresa, a
              adoção de práticas sustentáveis possibilitou a Vida Veg preservar
              cerca de 27 milhões de metros quadrados de terra, equivalente a
              2.705 campos de futebol; evitar a emissão de 7 milhões de quilos
              de CO2, equivalente a 63 milhões de quilômetros rodados em um
              carro ou mais de 1.575 voltas na terra; economizar mais de 916
              milhões de litros de água, que corresponde a 6,8 milhões de banhos
              de 15 minutos.
            </p>
            <p>
              Contudo, um grande desafio ligado à sustentabilidade dos processos
              da Vida Veg foi a adoção de embalagens mais sustentáveis, de forma
              que a parceria com o selo eu<b>reciclo</b> possibilitou a empresa
              a compensação das embalagens geradas, em conformidade com o
              propósito da marca de contribuir para um mundo melhor e mais
              sustentável.
            </p>
          </div>
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container even class="pa-0" title="Como o selo contribuiu">
          <div class="text-body">
            <p>
              1 - Realizamos a compensação ambiental das embalagens da marca,
              respeitando a distribuição de vendas pelo Brasil e a meta de
              reciclagem nacional (22%);
            </p>
            <p>
              2 - A marca passou a utilizar o selo eu<b>reciclo</b> nas
              embalagens e mídias sociais, garantindo uma comunicação direta com
              os consumidores conscientes;
            </p>
            <p>
              3 - Disponibilizamos periodicamente o Relatório de Impacto
              Socioambiental e garantias do incentivo à cadeia de reciclagem;
            </p>
            <p>
              4 - Oferecemos consultorias a fim de auxiliar a marca a reportar
              seus resultados aos órgãos reguladores sempre que necessário;
            </p>
            <p>
              5 - Oferecemos uma solução acessível, que atende os três pilares
              da sustentabilidade: social, ambiental e econômico.
            </p>
          </div>
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container
          even
          class="pa-0"
          title="Como a sustentabilidade pode gerar valor para as marcas?"
        >
          <div class="text-body">
            <p>
              “Não há mais espaço no mercado para empresas que não tem ações e
              produtos que promovam um consumo consciente. Hoje em dia é
              pré-requisito para qualquer empresa e produto pois é exigência da
              maioria dos consumidores que estão entendendo que precisamos mudar
              nossa forma de consumo, já que se continuarmos do mesmo faltarão
              recursos naturais para as próximas gerações e sofreremos com
              catástrofes ambientais. Para nossa empresa é essencial termos
              ações sustentáveis pois faz parte do nosso propósito. O retorno
              está diretamente relacionado a ter uma marca mais amada e
              referência em sustentabilidade.” Anderson Oliveira - CEO da Vida
              Veg
            </p>

            <p>
              Sabendo da importância da sustentabilidade aos olhos dos
              consumidores, cada vez mais conscientes e atentos às práticas das
              empresas, a Vida Veg trabalha essa perspectiva em diversas
              frentes. A marca prioriza fornecedores que possuam sinergia com as
              práticas sustentáveis, como o projeto social “Amigos do Bem”, que
              fornece castanhas-de-caju produzidas a partir da agricultura
              familiar no Nordeste, além de todos os fornecedores assinarem uma
              declaração atestando não utilizar produtos de origem animal ou por
              não realizar testes em animais. Com a adoção dessas práticas, além
              do selo da eu<b>reciclo</b>, a marca utiliza também o certificado
              de produtos veganos da Sociedade Vegetariana Brasileira para
              agregar valor ao seu produto.
            </p>
          </div>
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container
          even
          class="pa-0"
          title="Ações de marketing e engajamento"
        >
          <div class="text-body">
            <p>
              Post exclusivo no Instagram da eureciclo falando da parceria e
              ações de sustentabilidade da marca
            </p>

            <div class="py-5">
              <v-img :src="Foto1" contain width="100%" max-height="350" />
            </div>

            <p>
              Live conjunta para apresentar o impacto positivo da marca aos
              consumidores
            </p>

            <div class="py-5">
              <v-img :src="Foto2" contain width="100%" max-height="350" />
            </div>
          </div>
        </highlight-container>
      </v-col>
    </v-row>
  </case>
</template>

<script>
export default {
  name: 'MaisMu',
  metaInfo: {
    title: 'Case Vida Veg',
  },
  components: {
    Case: () => import('@/components/Case.vue'),
    HighlightContainer: () => import('@/components/HighlightContainer.vue'),
  },
  data() {
    return {
      Banner: require('@/assets/images/cases/vidaveg/banner.jpg'),
      Foto1: require('@/assets/images/cases/vidaveg/foto1.png'),
      Foto2: require('@/assets/images/cases/vidaveg/foto2.png'),
      box1: {
        title: 'Sobre a Vida Veg',
        text: `A Vida Veg foi criada em 2015 e é uma empresa essencialmente sustentável, que tem como missão contribuir para um mundo melhor, facilitando o acesso a alimentos de base vegetal, gostosos e saudáveis. A marca possui atualmente 30 produtos de base vegetal em mais de 3 mil pontos de venda em todo o Brasil. O trabalho da empresa contribui para a redução do impacto socioambiental da produção de alimentos, de forma a poupar milhares de animais do sofrimento e também contribuir para a saúde das pessoas e para um mundo mais sustentável. O objetivo da Vida Veg nos próximos anos é quintuplicar até 2023 a produção dos alimentos em relação a 2020.`,
      },
      box2: {
        title: 'Selo eureciclo',
        text: `Faça como a Vida Veg e torne-se uma empresa mais sustentável! Com o selo eu<b>reciclo</b>, sua empresa compensa o
              impacto das suas embalagens e adequa-se à legislação, além de incentivar o desenvolvimento da cadeia
              de reciclagem no Brasil e comunicar aos seus consumidores o seu engajamento.`,
        eventLabel: 'case-vidaveg',
      },
      intro: `Veja como a parceria com a eu<b>reciclo</b> contribuiu para solucionar um grande desafio da marca na sustentabilidade: as embalagens.`,
      results: [
        `Incentivou a coleta, a triagem e a destinação de massas proporcionais aos materiais da embalagem de seus produtos: 50% do Plástico e Papel`,
        'Resíduos compensados pelas centrais de triagem: 8.854 Kg de plástico e 11.600kg de papel',
        'A empresa beneficiou 3 operadores de reciclagem em 3 estados: MG, PR, e SP',
      ],
      color: '#59595c !important',
    };
  },
  mounted() {
    this.checkClass();
  },
  methods: {
    checkClass() {
      if (document.querySelector('.new-color')) {
        this.color = '#003036 !important';
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import "@/styles/util"
@import "@/styles/style"
</style>
